// extracted by mini-css-extract-plugin
export default {"image":"picture-module--image--935b4","wrapper":"picture-module--wrapper--89426"};